// React
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// Material UI
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import DoneIcon from '@mui/icons-material/Done';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// Style
import { useStyles } from 'components/dialogs/catalog/DialogCatalogInfo/DialogCatalogInfo.style';
// Facade
import Facade from 'core/Facade';
// Action
import CatalogAction from 'actions/CatalogAction';
// PCP Components
import Loader from 'components/commons/Loader';

const DialogCatalogInfo = ({ handleClose, open, catalog }) => {
    const [loading, setLoading] = useState(true);
    const [stats, setStats] = useState([]);
    const classes = useStyles();

    useEffect(() => {
        if (catalog) {
            setLoading(true);
            CatalogAction.getCatalog(catalog.siteId)
                .then(data => {
                    setStats(data);
                    setLoading(false);
                });
        }
    }, [catalog]);

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{'History of ' + catalog?.siteName}</DialogTitle>
            <DialogContent>
                {loading ?
                    <div className={classes.loaderContainer}><Loader size={50} /></div>
                    :
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell align='center' className={classes.headCell}>Tag</TableCell>
                                <TableCell align='center' className={classes.headCell}>Identified Categories</TableCell>
                                <TableCell align='center' className={classes.headCell}>Identified Products</TableCell>
                                <TableCell align='center' className={classes.headCell}>Scraped Products</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {stats.map((stat, key) =>
                                <TableRow key={key}>
                                    <TableCell component='th' scope='row'>
                                        {Facade.formatDate(new Date(stat.oldestDate))}
                                    </TableCell>
                                    <TableCell align='center'>{stat.tag}</TableCell>
                                    <TableCell align='center'>{stat.categoryCount}</TableCell>
                                    <TableCell align='center'>{stat.productCount}</TableCell>
                                    <TableCell align='center'>{stat.scrapedDataCount}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                }
            </DialogContent>
            <DialogActions>
                <IconButton color='primary' onClick={handleClose}>
                    <DoneIcon />
                </IconButton>
            </DialogActions>
        </Dialog>
    );
};

DialogCatalogInfo.propTypes = {
    handleClose: PropTypes.func,
    open: PropTypes.bool,
    siteName: PropTypes.string,
    catalog: PropTypes.object
};

export default DialogCatalogInfo;
